class AccessibilityUtility {
    /* Helper class for Accessibility */
    constructor() {

        //common keyboard keys for navigation and activation
        this.keys = {
            tab : 9,
            end : 35,
            home : 36,
            left : 37,
            up : 38,
            right : 39,
            down : 40,
            enter : 13,
            esc : 27,
            spacebar: 32,
            backspace: 8
        };
    }

    GetKeys() {
        return this.keys;
    }

    SetTabIndexSequential(element) {
        //Element is included in the tab sequence based on its position in the DOM.
        return element.attr('tabindex', 0);
    }

    SetTabIndexProgrammatic(element) {
        //Element is not included in the tab sequence but is focusable with focus().
        return element.attr('tabindex', -1);
    }
};

const accessibilityUtility = new AccessibilityUtility();

export default accessibilityUtility;


// WEBPACK FOOTER //
// ./assets/js/HSN/AccessibilityUtility.js